



















































import { Component, Prop, Vue } from 'vue-property-decorator';
import Topic from '../../components/topic.vue'
let curUnitId : number | null = null;

@Component({ components: { Topic } })
export default class Record extends Vue {
    @Prop()
    private formalId !: number;
    @Prop()
    private unitId !: number;

    private loading = false;
    private unitTree = [];
    private selUnit = [0];
    private nickName = "";

    private pagedData = [];
    private pageSize = 15;
    private pageIndex = 1;
    private total = 0;
    private multipleSelection: any[] = [];

    private reviewVisible = false;
    private topics = [];
    private singleNum = 0;
    private multipleNum = 0;
    private judgeNum = 0;
    private time = 0;
    private myAnswers: any[] = [];

    formatTime(row: any, column: any, cellValue: number) {
        return `${Math.floor(cellValue / 60)} 分${cellValue % 60} 秒`;
    }

    created() {
        this.reloadTree();
        this.reload();
    }

    // 加载机构树
    reloadTree() {
        this.$apis.getUnitTree(this.unitId)
            .then((res: any) => {
                this.unitTree = res.data;
            });
    }

    onUnitChange(value: number[]) {
        if (value.length == 0)
            curUnitId = null;
        else
            curUnitId = value[value.length - 1];
        this.reload();
    }

    reload() {
        this.$apis.getFormalRecords(this.formalId, curUnitId, this.nickName, this.pageIndex, this.pageSize)
            .then((res: any) => {
                this.total = res.total;
                this.pagedData = res.data;
            });
    }

    // 页面尺寸变化
    onSizeChange(val: any) {
        this.pageSize = val;
        this.pageIndex = 1;
        this.reload();
    }

    // 当前页变化
    onCurrentChange(val: any) {
        this.pageIndex = val;
        this.reload();
    }

    // 多选改变
    onSelectionChange(rows: any) {
        this.multipleSelection = rows;
    }

    // 单个删除和批量删除删除
    onDelete(id: number) {
        this.$confirm('此操作将删除选中的成绩, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            
            var ids = this.multipleSelection.map(item => item.userId);
            this.$apis.delFormalRecords(this.formalId, { data: { ids: ids } })
                .then((res: any) => {
                    this.reload(); // 刷新列表
                    
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                });
        });
    }

    onReview(id: number) {
        this.$apis.getFormalRecord(id, this.formalId)
            .then((res: any) => {
                this.reviewVisible = true;
                this.singleNum = res.data.singleNum;
                this.multipleNum = res.data.multipleNum;
                this.judgeNum = res.data.judgeNum;
                this.time = res.data.time;
                this.topics = res.data.topics;
                setTimeout(() => {
                    for (let i = 0; i < res.data.topics.length; ++i) {
                        (this.$refs[`topic${i}`] as any)[0].setMyAnswer(res.data.myAnswers[i]);
                        (this.$refs[`topic${i}`] as any)[0].show(true);
                    }
                }, 0);
            });
    }
}
